import cx from 'classnames'
import styles from './ToggleLight.module.css'

export interface ToggleLightProps {
  /** Label shown beside the switch */
  label: string
  /** Whether the switch is on */
  checked: boolean
  /** Called with the new state when the switch is toggled */
  onChange: (checked: boolean) => void
  /** Hint text when on */
  onHint?: string
  /** Hint text when off */
  offHint?: string
  /** Additional CSS class */
  className?: string
}

/**
 * A latching setting switch with a status lamp.
 * The lamp lights green when the switch is on.
 */
export function ToggleLight({
  label,
  checked,
  onChange,
  onHint = 'On',
  offHint = 'Off',
  className,
}: ToggleLightProps) {
  return (
    <div
      className={cx(styles.ToggleLight, className, {
        [styles.isOn]: checked,
      })}
    >
      <button
        className={styles.ToggleLight__switch}
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={label}
        onClick={() => onChange(!checked)}
      >
        <span className={styles.ToggleLight__knob} />
      </button>
      <span
        className={styles.ToggleLight__lamp}
        aria-hidden="true"
      />
      <span className={styles.ToggleLight__text}>
        <span className={styles.ToggleLight__label}>
          {label}
        </span>
        <span className={styles.ToggleLight__hint}>
          {checked ? onHint : offHint}
        </span>
      </span>
    </div>
  )
}
